import { Components, Theme } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid';

import { themeBase } from '../theme-base';

const { palette } = themeBase;
export const muiDataGrid: Theme['components'] = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        color: '#DDD',
        fontSize: '12px',
        backgroundColor: '#0F151C',
      },
      columnHeaderRow: {
        backgroundColor: palette.mapBlue[800],
      },
      columnHeaders: {
        [`& .${gridClasses.filler}`]: {
          backgroundColor: '#0F151C',
        },
        // borderStartStartRadius: 10,
      },

      columnHeader: {
        backgroundColor: palette.mapBlue[800],
        [`&.sticky-col`]: {
          backgroundColor: 'inherit',
        },
      },
      'container--top': {},
      headerCell: {
        color: '#ABB4BF',
      },
      cell: {
        color: palette.grey[200],
        [`&.sticky-col`]: {
          backgroundColor: 'inherit',
        },
      },
      footerCell: {
        color: '#ABB4BF',
      },
      ['scrollbar--vertical']: {
        height: 0,
      },
      scrollbar: {
        display: 'none',
      },
      virtualScrollerRenderZone: {
        backgroundColor: 'black',
      },
      row: {
        ['&.even']: {
          backgroundColor: '#0F151C',
        },
        ['&.odd']: {
          backgroundColor: '#101C26',
        },
        ['&:hover']: {
          backgroundColor: 'black',
          [`& .sticky-col`]: {
            backgroundColor: 'black',
          },
        },
        backgroundColor: '#191F26',
      },
      filler: {
        backgroundColor: '#0F151C',
      },
      selectedRow: {
        backgroundColor: '#46A000',
      },
      hoverRow: {
        backgroundColor: 'inherit',
      },
      iconButtonContainer: {
        visibility: 'visible',
        width: 'auto',
        [`.${gridClasses.sortButton}`]: {
          opacity: 1,
          backgroundColor: 'transparent',
        },
      },
      // menuIcon: {
      //   visibility: 'visible',
      //   width: 'auto',
      // },
      menuIconButton: {
        padding: 0,

        backgroundColor: 'transparent',
      },
    },
    defaultProps: {
      rowHeight: 40,
      columnHeaderHeight: 26,
    },
  } as Components['MuiDataGrid'],
};
